import axios from 'axios';
import Pagination from '@/domain/pagination.entity';
import BindItemDatasourceRequest from '@/domain/contract/request/bind-item-datasource-request.entity';
import ProductTemplate from '../entity/product-template.entity';
import ProductTemplateRule from '../entity/product-template-rule.entity';
import ProductTemplateRuleRequest from '../entity/product-template-rule-request.entity';

export default class ProductTemplateService {
  public static createProductTemplate(
    businessUnitId: string,
    params: CreateProductTemplateParams,
  ): Promise<ProductTemplate> {
    return axios.post(`/api/v1/business-units/${businessUnitId}/product-template`, params)
      .then((response: any) => new ProductTemplate(response.data))
  }

  public static createProductTemplateRule(
    businessUnitId: string,
    productTemplateId: string,
    params: ProductTemplateRuleRequest[],
  ): Promise<ProductTemplateRule> {
    return axios.put(`/api/v1/business-units/${businessUnitId}/product-template/${productTemplateId}/rules`, params)
      .then((response: any) => ProductTemplateRule.of(response.data));
  }

  public static deleteProductTemplate(productTemplateId: string): Promise<void> {
    return axios.delete(`/api/v1/product-template/${productTemplateId}`);
  }

  public static getAll(
    businessUnitId: string,
    filter: CreateProductTemplateParams,
    pagination: Pagination,
  ): Promise<any> {
    const params: any = {
      ...filter,
      page: pagination.page - 1,
      size: pagination.itemsPerPage,
      sortBy: pagination.arrangeSortBy,
    };
    return axios.get(`/api/v1/business-units/${businessUnitId}/product-template`, { params })
      .then((response) => response.data);
  }

  public static updateProductTemplateObservation(
    businessUnitId: string,
    productTemplateId: string,
    observation: string,
  ): Promise<void> {
    return axios.put(`/api/v1/business-units/${businessUnitId}/product-template/${productTemplateId}/observation`, { observation });
  }

  public static getRules(
    productTemplateId: string,
  ): Promise<ProductTemplateRule> {
    return axios.get(`/api/v1/product-template/${productTemplateId}/rules`)
      .then((response: any) => ProductTemplateRule.of(response.data));
  }

  public static bindProductTemplateDatasource(
    businessUnitId: string,
    productTemplateId: string,
    request: BindItemDatasourceRequest,
  ): Promise<void> {
    return axios.patch(`/api/v1/business-units/${businessUnitId}/product-template/${productTemplateId}/datasource`, request);
  }

  public static duplicateProductTemplate(
    businessUnitId: string,
    productTemplateId: string,
  ): Promise<ProductTemplate> {
    return axios.post(`/api/v1/business-units/${businessUnitId}/product-template/${productTemplateId}/duplicate`)
      .then((response: any) => new ProductTemplate(response.data));
  }
}

interface CreateProductTemplateParams {
  productId: number;
  description: string;
}
